import './App.css';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import NavBar from "./component/header/NavBar";
import {Urls} from "./component/const/Urls";
import Home from "./pages/Home";
import SignIn from "./pages/auth/SignIn";
import SignUp from "./pages/auth/SignUp";
import PopUps from "./component/ui/PopUps";
import {Create} from "./pages/modules/Create/Create";
import {Test} from "./pages/modules/Test/Test";
import {List} from "./pages/list/List";
import {Footer} from "./component/footer/Footer";
import {Pre} from "./pages/modules/Pre/Pre";
import {Feedback} from "./pages/modules/Feedback/Feedback";
import {Grading} from "./pages/modules/Grading/Grading";

export default function App() {
    return (
        <BrowserRouter>
            <NavBar/>
            <main >
            <Routes>
                <Route index Component={Home}/>
                <Route path={Urls.process(Urls.create)} Component={Create}/>
                <Route path={Urls.process(Urls.test)} Component={Test}/>
                <Route path={Urls.process(Urls.pre)} Component={Pre}/>
                <Route path={Urls.process(Urls.grade)} Component={Grading}/>
                <Route path={Urls.process(Urls.feedback)} Component={Feedback}/>
                <Route path='/signin' Component={SignIn}/>
                <Route path='/signup' Component={SignUp}/>
                <Route path={Urls.process(Urls.myPage)} Component={List}/>
            </Routes>
            </main>
            <Footer/>
            <PopUps/>
        </BrowserRouter>
    );
}
